<script setup>

const url = useRequestURL()

const { data: page } = await useAPIFetch('Newsletter')

useHead({
  bodyAttrs: {
    class: 'no-logo'
  }
})

useHeadData({
	title: page.value.meta.title,
	description: page.value.meta.description,
	author: page.value.meta.author,
	copyright: page.value.meta.copyright,
	keywords: page.value.meta.keywords,
	og: page.value.meta.og,
	url: url.href
})

</script>

<template>
	<div class="container mt-10">
		<div class="grid grid-cols-2">
			<div class="col-span-2 xl:col-span-1">
				<h1 class="text-red mb-8 h2">{{ page.attrs.title }}</h1>
				<WysiwygPerexSmall class="mb-8 xl:mb-10" :value="page.attrs.perex" />
				<ClientOnly>
					<FormNewsletter withoutTitle />
				</ClientOnly>
			</div>
		</div>
	</div>
</template>